import apiUrl from "../utils/apiUrl";
import fetch from "../utils/mgFetch";

const deleteUserTenantConnection = (token, id) => {
    return fetch(`${apiUrl}user_tenant_connections/${id}`, {
        method: "DELETE",
        headers: {
            Authorization: `Bearer ${token}`
        }
    });
}

export default deleteUserTenantConnection